import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useContext, useEffect, useState } from "react";
import { MapContext } from '../../../map-container/map/MapContext';
import { useAppSelector } from '../../../../../state/hooks';
import { Modify, Translate } from 'ol/interaction';
import Collection from 'ol/Collection';
import { GeoJSON } from 'ol/format';
import WFS from 'ol/format/WFS';
import GML from 'ol/format/GML';
import Feature from 'ol/Feature';
import { MultiLineString, MultiPolygon, MultiPoint } from 'ol/geom';
import { DigitizationRestApi } from "../../../../../util/restapi/digitization";
import { setPanoramaTransactStatus } from '../../../../../state/features/digitizationSlice';
import { DigiCallbackContext } from '../DigiCallbackContextProvider';
import { FeatureRestApi } from '../../../../../util/restapi/features';
import { setButtonState } from '../../../../../state/features/buttonStateSlice';
import { ButtonState } from '../../../../shared/button-state/ButtonState';
import { setSelectedFeature } from '../../../../../state/features/selectedFeatureSlice';
import { setFeatures } from '../../../../../state/features/tableSlice';

interface ModifyEndEvent {
    features: any//Collection;
    mapBrowserEvent: {
      coordinate: number[];
      originalEvent: PointerEvent;
      [key: string]: any;
    };
    target: Modify;
    type: string;
  }
  
export const MoveFeature = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [selectedFeature]: any = useAppSelector(state => state.selectedFeature.feature)
    const [translate, setTranslate] = useState<Translate>(new Translate())
    const [featureForTranslate, setFeatureForTranslate] = useState<any>()
    const services: any = useAppSelector(state => state.layer.services)

    const map = useContext(MapContext)
    const [modifyChangeEvent, setModifyChangeEvent] = useState<any>()
    let layerAndWorkspace : any ;
    const digiCallback = useContext(DigiCallbackContext);

    useEffect(() => {
        const content = map.getTargetElement();
        content.addEventListener('contextmenu',rightClickHandler);
        if(translate){
            translate.un('translateend', translateEnd);
            map.removeInteraction(translate);
        }
        setFeatureForTranslate(selectedFeature)
        addTranslateInteraction()

        return () => {
            map.removeInteraction(translate);
            content.removeEventListener('contextmenu', rightClickHandler)
        
        }

    }, [selectedFeature, modifyChangeEvent]);


    const rightClickHandler = (event: MouseEvent) => {
        const feature = modifyChangeEvent;
        const olGeoJson = new GeoJSON();

        const geoJsonFinal:any = olGeoJson.writeFeatureObject(feature);
        
        delete geoJsonFinal.properties.bbox;

        const isModify = window.confirm("Save Moved Feature? ");

        if (isModify) {
            let newFeature:any = new Feature()
            newFeature.setProperties(geoJsonFinal.properties)
            newFeature.setGeometryName('geom')

            const type = geoJsonFinal.geometry.type

            let newGeom :any 

            if(type ==="MultiPoint"){

                newGeom = new MultiPoint(geoJsonFinal.geometry.coordinates)
                
            }else if(type ==="MultiLineString"){

                newGeom = new MultiLineString(geoJsonFinal.geometry.coordinates)
            }else if(type ==="MultiPolygon"){

                newGeom = new MultiPolygon(geoJsonFinal.geometry.coordinates)
            }
      
            newFeature.setGeometry(newGeom)

            
            layerAndWorkspace = getLayerAndService(selectedFeature.id, services)

            let formatWFS :any= new WFS();

            let formatGML = new GML({
                featureNS: layerAndWorkspace.service.workspace,
                featureType: layerAndWorkspace.layer.name,
                srsName: 'EPSG:3857',
                hasZ: true,
            });
    
            let xs = new XMLSerializer();
    
    
            let node: any;
            node = formatWFS.writeTransaction([newFeature], null, null, formatGML);

            let payload = xs.serializeToString(node)

            newFeature.unset('bbox', true)
            newFeature.unset('key', true)
            newFeature.unset('label', true)



            DigitizationRestApi.digiAddFeature(payload, layerAndWorkspace.service.url).then((res: any) => {
                if (res) {
                    // dispatch(setToastMessageStatus(true))
                    dispatch(setPanoramaTransactStatus(false))
                }

                const featureId = res.split('.')[1]
                // if (typeof (window as any).addDigiCallback === 'function') {
                //     (window as any).addDigiCallback(featureId)
                // }
                if (typeof digiCallback.callbackFunction === 'function') {
                    digiCallback.callbackFunction(featureId)
                }

                
                let formatWFS :any= new WFS();
                let xs = new XMLSerializer();
  
                 const deleteFeature = new GeoJSON().readFeature(selectedFeature)
                 //@ts-ignore
                 node = formatWFS.writeTransaction(null, null, [deleteFeature], formatGML);
          
                  payload = xs.serializeToString(node)
                 
                  DigitizationRestApi.digiAddFeature(payload, layerAndWorkspace.service.url).then((res: any) => {
                    
                    if (res) {
                        // dispatch(setToastMessageStatus(true))
                        dispatch(setPanoramaTransactStatus(false))
                    }
                    // insert yapiliyorsa geoservera istek yapip featureId yi alacak o id ile attachment istegi yapacak
  
                    const featureId = res.split('.')[1]
                    if (typeof digiCallback.callbackFunction === 'function') {
                        digiCallback.callbackFunction(featureId)
                    }

                // FeatureRestApi.getFeatures(layerAndWorkspace.service.url, layerAndWorkspace.layer.name).then((res: any) => {
                //     if (res) {
                      
                //         dispatch(setFeatures(res.data.features));

                        // map update 
                        const layersOfMap = map.getLayers();
                
                        layersOfMap.forEach((layer: any) => {
                            let source: any = layer.getSource();
                            if (source.updateParams !== undefined)
                                source.updateParams({ 'time': Date.now() });
                        });
                        
                        dispatch(setPanoramaTransactStatus(undefined))
                        dispatch(setButtonState(ButtonState.NONE))
                        dispatch(setSelectedFeature([]))
                        
                        map.updateSize();
                        map.render();
                //     }
                // })

                const intrcts = (window as any).olMap.getInteractions().getArray()
                intrcts.forEach((interaction: any) => {
                    if (interaction instanceof Translate) {
                        (window as any).olMap.removeInteraction(interaction)
                    }
                })
            })
            })
        } else{
            dispatch(setPanoramaTransactStatus(undefined))
            dispatch(setButtonState(ButtonState.NONE))
            dispatch(setSelectedFeature([]))
        }

      }


      const getLayerAndService = (featureId: string, services: any) => {
        let service;
        let layer;
        const layerName = featureId.split('.')[0]
    
        for (const item of services) {
          for (const testLayer of item.layers) {
            if (testLayer.name === layerName) {
              layer = testLayer
              service = item
            }
          }
        }
        const obj = {
          layer: layer,
          service: service
        }
        return obj
      }

    const modifyEvent = (event:any): void => {
        if (event) {
            setModifyChangeEvent(event)
        } else {
            setModifyChangeEvent(undefined)
        }
      }
    

    const addTranslateInteraction = (): void => {
        const collection = new Collection([featureForTranslate])

        setTranslate(new Translate({
            features: collection
          }))

        map.addInteraction(translate);
        translate.on('translateend', translateEnd);
    }


    const translateEnd = (event: ModifyEndEvent) => {
        const feature = event.features.item(0);
        if (!feature) {
            modifyEvent(false);
            return;
        }
        modifyEvent(feature);
    }

    return (
        <>

        </>
    )
};